import { initStickyObserver } from './controller/_sticky';

export default function() {
  initStickyObserver();
}
